import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { ZoomableImage } from '../../../common/zoomable-image';
import { CarouselImage } from '../carousel-image';
import iconLeftChevron from './icon-left-chevron.svg';
import iconRightChevron from './icon-right-chevron.svg';
import styles from './ImageCarousel.css';
import { ProductStore } from '../stores/ProductStore';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const IMAGE_CARD_WIDTH = 145;

class ImageCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      imageOffset: 0,
    };
    this.imageList = null;
    this._decreaseOffset = this._decreaseOffset.bind(this);
    this._increaseOffset = this._increaseOffset.bind(this);
    this._renderImageList = this._renderImageList.bind(this);
    this._updateImageList = this._updateImageList.bind(this);
  }

  _renderImageList(images) {
    return (
      images.map((image, index) => (
        /* eslint-disable-next-line max-len */
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
        <div
          className={[styles.imageBox, this.state.currentIndex === index ? styles.selected : ''].join(' ')}
          key={image}
          onClick={() => this._swapMainImage(index)}
        >
          <div className={styles.imageFlex}>
            <CarouselImage src={image} />
          </div>
        </div>
      ))
    );
  }

  _swapMainImage(newIndex) {
    this.setState({
      currentIndex: newIndex,
    });
  }

  _updateImageList(element) {
    this.imageList = element;
  }

  _decreaseOffset() {
    this.setState((prevState) => {
      const newOffset = Math.max(0, prevState.imageOffset - 1);
      return {
        imageOffset: newOffset,
      };
    });
  }

  _increaseOffset() {
    this.setState((prevState) => {
      const { product: { images } } = ProductStore;
      const imagesOnScreen = Math.floor(this.imageList.clientWidth / IMAGE_CARD_WIDTH);
      let newOffset = Math.min(prevState.imageOffset + 1, images.length - imagesOnScreen);
      if (newOffset < 0) {
        newOffset = 0;
      }
      return {
        imageOffset: newOffset,
      };
    });
  }

  render() {
    const { product: { images } } = ProductStore;
    if (!images.length) {
      return null;
    }
    return (
      <div className={this.props.className}>
        <div className={styles.mainImageContainer}>
          <ZoomableImage
            className={styles.mainImage}
            component={CarouselImage}
            src={images[this.state.currentIndex]}
          />
        </div>
        <div className={styles.imageListContainer}>
          <button
            className={styles.chevronContainer}
            onClick={this._decreaseOffset}
          >
            <img src={iconLeftChevron} alt="" />
          </button>
          <div
            className={styles.imageListWrapper}
            ref={this._updateImageList}
          >
            <div
              className={styles.imageList}
              style={{
                transition: 'transform 0.3s',
                transform: `translateX(-${this.state.imageOffset * IMAGE_CARD_WIDTH}px)`,
              }}
            >
              {this._renderImageList(images)}
            </div>
          </div>
          <button
            className={styles.chevronContainer}
            onClick={this._increaseOffset}
          >
            <img src={iconRightChevron} alt="" />
          </button>
        </div>
      </div>
    );
  }
}

ImageCarousel.propTypes = IPropTypes;
ImageCarousel.defaultProps = defaultProps;

const WrappedImageCarousel = observer(ImageCarousel);

export { WrappedImageCarousel as ImageCarousel };



// WEBPACK FOOTER //
// ./src/pages/product-detail/image-carousel/ImageCarousel.jsx